/**
|--------------------------------------------------
| All routing paths for Account.
| Note: No '/' at the end.
|--------------------------------------------------
*/

export const RoutePath = {
	allocateFunds: '/allocatefunds',
	cancelAccount: '/cancelaccount',
	changePassword: '/changepassword',
	changePlan: '/changeplan',
	commPrefs: '/commprefs',
	costCodes: '/costcodes',
	contactInfo: '/contactinfo',
	emails: '/emails',
	locationContactInfo: '/locationcontactinfo',
	locationPaymentMethods: '/locationpaymentmethods',
	locationPaymentSettings: '/locationpaymentsettings',
	locations: '/locations',
	locationUsers: '/locationusers',
	paymentMethods: '/paymentmethods',
	paymentSettings: '/paymentsettings',
	referAFriend: '/referafriend',
	refundEligibilityReport: '/refundeligibilityreport',
	regions: '/regions',
	signIn: '/signin',
	userContactInfo: '/usercontactinfo',
	users: '/users',
	verify: '/verify',
	shipFromAddress: '/shipfromaddress',
	addPayment: '/addpaymentmethod',
	addPaymentSettings: '/paymentsettings/add',
	labs: '/labs',
};
